import React from "react";
import { classNames } from "../../tools/ClassNames"

const Stats = ({
  stats,
  seleccionarPedidos,
  option,
  esProveedor = false
}) => {
  function show(item, index, length) {
    return (
      <div
        key={item.id}
        className={classNames(
          item.id === option ? "bg-primarioMira " : "bg-secundarioMira ",
          ` relative overflow-hidden rounded-lg  px-2 pb-12 pt-5 shadow shadow-white md:w-1/${length} md:justify-between grid grid-cols-2 md:flex md:flex-col md:w-full `
        )}
      >
        <div className="flex flex-col h-full self-between m-2">

          <div className="self-start h-1/2">
            <p className="text-sm text-gray-400 flex">
              {item?.name}
            </p>
          </div>

        <div className="items-between h-1/2">
          <div className="flex flex-row w-full self-end">
            <div
              className={classNames(
                ["Pagado", "Entregado", "Recibido"].includes(item.Estatus)
                ? " text-blue-500"
                : ["Revisado"].includes(item.Estatus)
                ? " text-green-500"
                  : ["Recepción Parcial", "Entrega Parcial"].includes(item.Estatus)
                  ? " text-yellow-500"
                  : ["Pendiente de Recibir"].includes(item.Estatus)
                  ? " text-orange-500"
                  : ["Todos"].includes(item.Estatus)
                  ? " text-gray-500"
                  : ["Pendiente", "Pedido", "Pendiente de Revisar"].includes(item.Estatus) 
                  && " text-red-500",
                "hidden lg:inline-flex rounded-md p-1 truncate text-5xl font-medium items-center flex-row"
              )}
            >
              <item.icon aria-hidden="true" className="h-8 w-8" />
            </div>
            <p className="text-4xl font-semibold text-gray-100 mx-auto">
              {item?.stat}
            </p>
          </div>
        </div>
        
        <dd className="cursor-pointer">
          <div
            className="absolute inset-x-0 bottom-0 px-2 py-2 sm:px-6 rounded-b-md px-auto text-center text-gray-100 hover:bg-secundario bg-azulBrillanteMira justify-center transition duration-500 ease flex flex-row"
            onClick={() => seleccionarPedidos(item?.id)}
          ><p className="my-auto /font-medium">Ver</p>{/*<ChevronRightIcon className="w-5 h-5 ml-1 my-auto"/>*/}
            
          </div>
        </dd>
      </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-xl font-medium leading-6 text-gray-100 mb-2">{`Resumen de ${esProveedor?"pedidos":"envíos"}`}</h3>

      <div className="grid grid-cols-2 md:flex md:flex-row gap-2 lg:w-[100%] mb-2">
        {/* mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 */}
        {stats.length > 0 &&
          stats.map((item, index) => show(item, index, stats.length))}
      </div>
    </div>
  );
};

export { Stats as default };
